(function () {
  function initLoadMore(root) {
    root.querySelectorAll('[data-flow-load-more]').forEach(function (btn) {
      var panel = btn.closest('[data-flow-category]') || btn.closest('[data-flow-view]') || root;
      var grid = panel.querySelector('[data-flow-grid]');
      if (!grid) return;

      btn.addEventListener('click', function () {
        var batch = parseInt(btn.getAttribute('data-batch') || '6', 10);
        var hidden = grid.querySelectorAll('.fabpad-flow__card--hidden');

        for (var i = 0; i < batch && i < hidden.length; i++) {
          hidden[i].classList.remove('fabpad-flow__card--hidden');
          hidden[i].removeAttribute('hidden');
        }

        if (!grid.querySelector('.fabpad-flow__card--hidden')) {
          var wrap = btn.closest('.fabpad-flow__load-wrap');
          if (wrap) wrap.hidden = true;
        }
      });
    });
  }

  function initCategoryNav(root) {
    var cat = new URLSearchParams(window.location.search).get('cat');
    if (!cat) return;

    var activePanel = root.querySelector('[data-flow-category="' + cat + '"]');
    if (!activePanel) return;

    var track = activePanel.querySelector('[data-flow-category-nav]');
    if (!track) return;

    var active = track.querySelector('.fabpad-flow__category-nav-item--active');
    if (active && track.scrollWidth > track.clientWidth) {
      var offset = active.offsetLeft - track.clientWidth / 2 + active.offsetWidth / 2;
      track.scrollLeft = Math.max(0, offset);
    }
  }

  function initCategoryView(root) {
    var cat = new URLSearchParams(window.location.search).get('cat');
    var hub = root.querySelector('[data-flow-view="hub"]');
    var panels = root.querySelectorAll('[data-flow-category]');

    if (!cat) {
      if (hub) hub.hidden = false;
      panels.forEach(function (panel) {
        panel.hidden = true;
      });
      return;
    }

    if (hub) hub.hidden = true;
    panels.forEach(function (panel) {
      panel.hidden = panel.getAttribute('data-flow-category') !== cat;
    });

    var activePanel = root.querySelector('[data-flow-category="' + cat + '"]');
    if (activePanel) {
      activePanel.hidden = false;
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    var flow = document.querySelector('[data-fabpad-flow]');
    if (!flow) return;
    initCategoryView(flow);
    initLoadMore(flow);
    initCategoryNav(flow);
  });
})();
